module.exports = __webpack_public_path__ + "static/media/DetailsFigure.8b033cd2.png";